/**
 * The roads not taken.
 *
 * At every past node there were four to six options and the player took one. These are
 * the others: near-invisible dots on the far side of a history node. They are deliberately
 * at the edge of perception — the point is a faint sense that the path had alternatives,
 * not an invitation to go back and audit them. Anything more legible would turn a doodle
 * into a decision tree.
 */

import { CONNECTOR_OPACITY, adventurousnessTint } from './motion.js';

export interface GhostStub {
  id: string;
  /** Tints the stub, exactly as it tinted the card it was offered on. */
  adventurousness: number;
  /** For assistive technology only; never painted. */
  label: string;
}

export function GhostStubs({ stubs }: { stubs: readonly GhostStub[] }): React.JSX.Element | null {
  if (stubs.length === 0) return null;
  return (
    <span
      className="hc-ghosts"
      data-testid="hc-ghost-stubs"
      data-count={stubs.length}
      aria-label={`${stubs.length} options not taken: ${stubs.map((s) => s.label).join(', ')}`}
    >
      {stubs.map((stub) => (
        <span
          key={stub.id}
          className="hc-ghost"
          aria-hidden="true"
          style={{
            // A fifth of the connector's already-quiet opacity. Present, not readable.
            background: adventurousnessTint(stub.adventurousness),
            opacity: CONNECTOR_OPACITY * 0.22,
          }}
        />
      ))}
    </span>
  );
}
